import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";

type BaseStatusScreenProps = {
  icon?: React.ReactNode;
  title: string;
  description: string;
  iconWrapperClassName?: string;
  wrapperClass?: string;
};

type StatusScreenProps =
  | (BaseStatusScreenProps & {
      variant: "link-button";
      buttonText: string;
      buttonLink: string;
    })
  | (BaseStatusScreenProps & {
      variant: "actions";
      actions: React.ReactNode;
    });

export default function StatusScreen({
  icon,
  title,
  description,
  iconWrapperClassName = "text-slate-500 bg-slate-100 dark:bg-slate-900 dark:text-slate-400",
  wrapperClass,
  ...props
}: StatusScreenProps) {
  return (
    <main
      className={cn(
        "flex min-h-screen flex-col p-4 bg-background items-center justify-center",
        wrapperClass
      )}
    >
      <Card className="border-none shadow-none bg-transparent max-w-md mx-auto">
        <CardHeader className="space-y-4">
          {icon && (
            <div
              className={cn(
                "flex items-center justify-center w-16 h-16 rounded-full mx-auto [&>svg]:size-8",
                iconWrapperClassName
              )}
            >
              {icon}
            </div>
          )}
          <CardTitle className="text-2xl text-center text-foreground">
            {title}
          </CardTitle>
          <CardDescription className="text-muted-foreground text-center">
            {description}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          {props.variant === "actions" ? (
            props.actions
          ) : (
            <Link
              to={props.buttonLink}
              className={cn(buttonVariants({ variant: "default" }))}
            >
              {props.buttonText}
            </Link>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
